var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseMappingCheckboxHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8889 3H4.11111C3.5 3 3 3.5 3 4.11111V11.8889C3 12.5 3.5 13 4.11111 13H11.8889C12.5 13 13 12.5 13 11.8889V4.11111C13 3.5 12.5 3 11.8889 3ZM11.8889 11.8889H4.11111V4.11111H11.8889V11.8889ZM11.3278 6.33333L10.5444 5.54444L6.88333 9.20556L5.45 7.77778L4.66111 8.56111L6.88333 10.7778L11.3278 6.33333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMappingCheckboxHeaderIcon);
export default __webpack_public_path__ + "static/media/course-mapping-checkbox-header-icon.f4d33e68422cfc16cccd70a5ac928cc4.svg";
export { ForwardRef as ReactComponent };